import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';

// 基础薪资分页列表
export const GetUserBaseSalaryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Salary/GetUserBaseSalaryPageList", params)
};
// 保存基础薪资信息
export const SaveUserBaseSalary = (params) => {
	return reqF("post", "/api/sysConfig/Salary/SaveUserBaseSalary", params)
};
// 获取基础薪资详情
export const GetUserBaseSalaryDetail = (params) => {
	return reqF("post", "/api/sysConfig/Salary/GetUserBaseSalaryDetail", params)
};
// 基础薪资调整历史分页列表
export const GetUserBaseSalaryHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Salary/GetUserBaseSalaryHistoryPageList", params)
};
// 月度工资分页列表
export const GetUserMonthSalaryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Salary/GetUserMonthSalaryPageList", params)
};
